import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { TravelLiquiditionService } from '../../services/travel-liquidition/travel-liquidition.service';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';

@Component({
  selector: 'app-travel-liquidation-cancel',
  templateUrl: './travel-liquidation-cancel.component.html',
  styleUrls: ['./travel-liquidation-cancel.component.scss']
})
export class TravelLiquidationCancelComponent implements OnInit {

  _travel: Travel;
  formGroup: FormGroup;
  loading:boolean;

  constructor(
    public dialogRef: MatDialogRef<TravelLiquidationCancelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public liquidationService: TravelLiquiditionService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this._travel = new Travel('');
    this.formGroup = this.formBuilder.group({
      status: ['',null],
      reason:['',null],
    });
  }

  
  closeOnClick() {
    this.dialogRef.close('');
  }

  save(){
    this.loading = true;
    if (this.data.status == undefined) {
      this.formGroup.controls['status'].setValue("Cancelled");
      this.liquidationService.updateStatus(this.data.id,this.formGroup.value).subscribe(res=>{
        this.loading = false;
        this.dialog.open(NotifyboxComponent , {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: res['message']
          }
        }).afterClosed().subscribe(result => {
          if (result) {
            this.dialogRef.close(true);
          }
        });
      }, (err => {
        this.loading = false;
        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: err.error.errors.reason ? err.error.errors.reason[0] : err.error.errors.push_back[0]
          }
        }).afterClosed().subscribe(result => {
          if (result) {
            // this.dialogRef.close(this.formGroup.value);
          }
        });
    }));
    } else {
      let status = "";
      if (this.data.status == 3) {
        status = "Approved";
      } else if (this.data.status == 4) {
        status = "Rejected";
      } else if (this.data.status == 5) {
        status = "Cancelled";
      } else if (this.data.status == 6) {
        status = "Push Back";
      }
      this.formGroup.controls['status'].setValue(status);
      this.liquidationService.approverUpdateStatus(this.data.id,this.formGroup.value).subscribe(res=>{
        this.loading = false;
        this.dialog.open(NotifyboxComponent , {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: res['message']
          }
        }).afterClosed().subscribe(result => {
          if (result) {
            this.dialogRef.close(this.formGroup.value);
          }
        });
      }, (err => {
        this.loading = false;
        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: err.error.errors.reason ? err.error.errors.reason[0] : err.error.errors.push_back[0]
          }
        }).afterClosed().subscribe(result => {
          if (result) {
            // this.dialogRef.close(this.formGroup.value);
          }
        });
    }));
    }

  }

}
